import { Button } from '@repo/shadcn';
import { DatabaseBackup, Loader2Icon, Reply, Save, Trash } from 'lucide-react';
import { Link } from 'react-router-dom';

import { ConfirmButton } from '@components/ui/button';

import { MODAL_ROUTE, Route } from '@/constants';
import { useModal } from '@/hooks';

import { useCart } from './cart.hook';

export const CartActions = () => {
    const {
        activeCart,
        isActiveCartFetching,
        isActiveCartLoading,
        clearCart,
        isClearCartLoading,
    } = useCart();
    const { openModal } = useModal();

    const isLoading = isActiveCartLoading || isActiveCartFetching;
    const totalItems = activeCart?.data?.items.length || 0;

    const handleSaveAsDraftClick = () => {
        openModal(MODAL_ROUTE.CART_SAVE_AS_DRAFT);
    };

    const handleClearCartClick = async () => {
        console.log('handle clear cart clicked');
        await clearCart(null).unwrap();
    };

    const handleRestoreCartClick = () => {
        openModal(MODAL_ROUTE.CART_DRAFT_LIST);
    };

    return (
        <div className="mb-4 flex items-center justify-between">
            <div>
                <p className="text-lg font-medium leading-tight">
                    Total Items:{' '}
                    {isLoading ? (
                        <Loader2Icon
                            className="inline-block animate-spin"
                            size={16}
                        />
                    ) : (
                        totalItems
                    )}
                </p>
            </div>
            <div className="flex flex-wrap justify-end gap-2">
                <Link to={Route.SALES_RETURN_CREATE}>
                    <Button
                        type="button"
                        className="flex items-center gap-0.5 bg-slate-100 text-slate-800 hover:bg-slate-200 hover:text-slate-900  disabled:cursor-not-allowed "
                        variant={'outline'}
                    >
                        <Reply size={18} />
                        Sales Return
                    </Button>
                </Link>
                <Button
                    type="button"
                    className="flex items-center gap-0.5 bg-yellow-100 text-yellow-800 hover:bg-yellow-200 hover:text-yellow-900  disabled:cursor-not-allowed "
                    variant={'outline'}
                    disabled={totalItems === 0}
                    onClick={handleSaveAsDraftClick}
                >
                    <Save size={18} />
                    Save as Draft
                </Button>
                <Button
                    type="button"
                    variant={'outline'}
                    className="flex items-center gap-0.5 bg-green-100 text-green-800 hover:bg-green-200 hover:text-green-900  disabled:cursor-not-allowed "
                    disabled={totalItems !== 0}
                    onClick={handleRestoreCartClick}
                >
                    <DatabaseBackup size={18} />
                    Restore Cart
                </Button>

                <ConfirmButton
                    confirmText={'Are you sure you want to clear the cart?'}
                    handleConfirm={handleClearCartClick}
                >
                    <Button
                        type="button"
                        variant={'outline'}
                        className="flex items-center gap-0.5 bg-red-100 text-red-800 hover:bg-red-200 hover:text-red-900 disabled:cursor-not-allowed "
                        disabled={totalItems === 0}
                    >
                        {isClearCartLoading ? (
                            <Loader2Icon className={'animate-spin'} />
                        ) : (
                            <>
                                <Trash size={18} />
                                Clear Cart
                            </>
                        )}
                    </Button>
                </ConfirmButton>
            </div>{' '}
        </div>
    );
};

CartActions.displayName = 'CartActions';
